import React, { useState, useLayoutEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useRecoilValue } from "recoil";
import { staticAppConfig } from "../AppData/Recoil";

export const OneXPageTemplate = ({ showDebug, debugComponent, children }) => {
  const [visible, setVisible] = useState(false);
  const wrapperRef = useRef(null);

  useLayoutEffect(() => {

    if (!visible) {
      setTimeout(() => {
        setVisible(true);
      }, 500);
    }

    const currentRef = wrapperRef.current;

    window.oneX.addElement(currentRef);

    return () => {
      try {
        window.oneX.removeElement(currentRef);
      } catch (error) {
      }
    }
  }, [visible]);

  return (
    <div ref={wrapperRef}>
      <div
        style={{
          transition: "all 500ms ease-in-out",
          opacity: `${visible ? "1" : "0"}`,
        }}
      >
        <header data-type="1x-header-unauth" data-limited="true"></header>
        <div className="-oneX-container" style={{display:"flex", justifyContent: "center"}}>{children}</div>
        <footer data-type="1x-footer" data-limited="true"></footer>
        {showDebug ? debugComponent : null}
      </div>
    </div>
  );
};

const OneXPageContainer = ({ children }) => {
  const appConfig = useRecoilValue(staticAppConfig);

  return (
    <OneXPageTemplate showDebug={appConfig.debugMode} debugComponent={<div>Global state needs to be reimplemented with Recoil.js</div>}>
      {children}
    </OneXPageTemplate>
  );
};

export default OneXPageContainer;

OneXPageTemplate.defaultProps = {
  showDebug: false,
};

OneXPageTemplate.propTypes = {
  showDebug: PropTypes.bool,
  debugComponent: PropTypes.element,
  children: PropTypes.element.isRequired,
};

OneXPageContainer.propTypes = {
  children: PropTypes.any.isRequired,
};
